import { z } from "zod";
import { apiIntIdSchema } from "./ids.js";
import { ORGANIZATION_MEMBER_ROLES } from "./constants.js";
import { MEMBER_DISPLAY_NAME_MAX_LENGTH, TEAM_INVITE_BATCH_MAX, TEAM_INVITE_ROLES, } from "./team-access.js";
export const updateOwnMemberProfileRequestSchema = z
    .object({
    displayName: z.string().trim().min(1).max(MEMBER_DISPLAY_NAME_MAX_LENGTH),
})
    .strict();
export const updateOwnMemberProfileResponseSchema = z.object({
    membershipId: apiIntIdSchema,
    displayName: z.string(),
});
export const updateMemberRoleRequestSchema = z
    .object({
    role: z.enum(TEAM_INVITE_ROLES),
})
    .strict();
export const teamMemberSchema = z.object({
    membershipId: apiIntIdSchema,
    email: z.string().email(),
    displayName: z.string(),
    role: z.enum(ORGANIZATION_MEMBER_ROLES),
    status: z.enum(["ACTIVE", "SUSPENDED"]),
    isCurrentUser: z.boolean(),
});
export const teamInvitationStatusSchema = z.enum(["PENDING", "EXPIRED", "CANCELLED"]);
export const teamInvitationSchema = z.object({
    invitationId: apiIntIdSchema,
    displayName: z.string(),
    email: z.string().email(),
    role: z.enum(TEAM_INVITE_ROLES),
    status: teamInvitationStatusSchema,
    expiresAt: z.string(),
    createdAt: z.string(),
});
export const teamListResponseSchema = z.object({
    members: z.array(teamMemberSchema),
    invitations: z.array(teamInvitationSchema),
});
export const inviteRecipientEmailSchema = z.string().trim().email();
export const createTeamInvitationsRequestSchema = z
    .object({
    invitations: z
        .array(z.object({
        displayName: z.string(),
        email: inviteRecipientEmailSchema,
        role: z.enum(TEAM_INVITE_ROLES),
    }))
        .min(1)
        .max(TEAM_INVITE_BATCH_MAX),
})
    .strict();
export const createTeamInvitationsResponseSchema = z.object({
    emailDelivery: z.literal("not_configured"),
    invitations: z.array(teamInvitationSchema),
});
export const acceptInvitationRequestSchema = z
    .object({
    token: z.string().trim().min(20).max(256),
})
    .strict();
export const pendingInvitationSchema = z.object({
    invitationId: apiIntIdSchema,
    organizationId: apiIntIdSchema,
    organizationName: z.string(),
    displayName: z.string(),
    role: z.enum(TEAM_INVITE_ROLES),
    expiresAt: z.string(),
});
export const pendingInvitationListResponseSchema = z.object({
    invitations: z.array(pendingInvitationSchema),
});
export const acceptInvitationResponseSchema = z.object({
    organizationId: apiIntIdSchema,
    membershipId: apiIntIdSchema,
    role: z.enum(TEAM_INVITE_ROLES),
    memberDisplayName: z.string(),
});
//# sourceMappingURL=team-contracts.js.map